import { PushNotificationsService } from './push-notification/push-notification-service';
import { Component, OnInit, Inject, AfterViewInit, OnDestroy, HostListener, Directive, DOCUMENT } from '@angular/core';
import { HttpRequest, HttpEventType, HttpClient } from '@angular/common/http';
import { Router, Event, NavigationEnd, ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';
import { HeaderService } from './components/header/header.service';
import { LoaderComponent } from './loader/loader.component';
import { SocketService } from './socket/socket.service';
import { SettingsService } from './components/settings/settings.service';
import { AlertPopup, BASE_URI } from './app.config';
import { DataSharingService } from './shared/data-sharing.service';

import { UserService } from './components/userandgroup/user/user.service';
import { GuidedTour, GuidedTourService, Orientation, ProgressIndicatorLocation } from 'ngx-guided-tour';

import { ThemeService } from './components/settings/theme.service';
import { LoginService } from './components/login/login.service';
import { AssistBotService } from './components/ai-assist/assist-bot.service';
import { LlmService } from './services/llm.service';
import { IndexedDBService } from './services/indexed-db.service';
import { BotService } from './ibm-bot/bot.service';
import { filter } from 'rxjs';
import { CoreService } from './services/core.service';
// @Directive()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  },
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'app';
  isWindowFocused = true;
  public userLoggin = false;
  public loggedUserRole: any;
  public currectActiveToken: any;
  public userSetting: any = {};
  public callingUserDetails: any = {}
  public menuListItem: any;
  public userDetail: any;
  public selectedFilesList: any[] = [];
  public userStatus = [];
  is_tour_completed = false;
  public activated!: {
    loginPage: boolean;
  };

  subscribers: any = {
    isSubscribed: false
  };
  actualUrl: any;
  activeUrl: any;

  progressIndicatorLocation: any;
  GuidedTour!: GuidedTour;

  isSidebarCollapsed = false;
  isMobileSidebarOpen = false;

  isMobile = false;
  // private socket;

  constructor(
    private http: HttpClient,
    private socketService: SocketService,
    private headerService: HeaderService,
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    private router: Router,
    private dataSharingService: DataSharingService,
    @Inject(DOCUMENT) private document: Document,
    private userService: UserService,
    private _notificationService: PushNotificationsService,
    private alert: AlertPopup,
    private guidedTourService: GuidedTourService,
    private themeService: ThemeService,
    private loginService: LoginService,
    private assistBotService: AssistBotService, private llmService: LlmService,
    private indexedDBService: IndexedDBService,
    private botService: BotService,
    private coreService: CoreService
  ) {
    this._notificationService.requestPermission();

    this.progressIndicatorLocation = ProgressIndicatorLocation.TopOfTourBlock;

    this.activated = {
      loginPage: false
    };


    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe({
        next: (event) => {

          const urlTree = this.router.parseUrl(event.urlAfterRedirects);

          this.activeUrl = urlTree.root.children['primary']?.segments[0]?.path || '';
          this.actualUrl = urlTree.root.children['primary']?.segments[1]?.path || '';

          const authRoutes = [
            'login',
            'signup',
            'set_password',
            'forgot_password',
            'verify_otp'
          ];

          this.activated.loginPage = authRoutes.includes(this.activeUrl);
        },
        error: (error) => {
          console.error(error);
        }
      });

    // this.hintService.overlay$.subscribe(data => {
    //   if (!data) {
    //     this.updateUserOnboarding();
    //   }
    // });
  }

  onResize(event: any) {
    event.target.innerWidth; // window width
  }


  dragOverHandler = (e: any) => {
    e.preventDefault();
  }

  dropHandler = (e: any) => {
    e.preventDefault();
  }

  focusHandler = (e: any) => {
    e.preventDefault();
    this.isWindowFocused = true;
  };

  focusBlurHandler = (e: any) => {
    this.isWindowFocused = false;
  };

  ngOnInit(): void {
    // window.addEventListener('dragover', function (e) {
    //   e.preventDefault();
    // }, false);

    // window.addEventListener('drop', function (e) {
    //   e.preventDefault();
    // }, false);

    // window.addEventListener('focus', (e) => {
    //   e.preventDefault();
    //   this.isWindowFocused = true;
    // });

    // window.addEventListener('blur', (e) => {
    //   e.preventDefault();
    //   this.isWindowFocused = false;
    // });

    window.addEventListener('dragover', this.dragOverHandler, false);
    window.addEventListener('drop', this.dropHandler, false);
    window.addEventListener('focus', this.focusHandler, false);
    window.addEventListener('blur', this.focusBlurHandler, false);



    if (window.localStorage.token) {
      this.getUserStatusData();
      this.getCurrentUserData();
      this.loggedUserRole = localStorage.getItem('user_role');
    } else {
      window.localStorage.clear();
    }

    // const userId = String(localStorage.getItem('user_id'));
    // this.socket = this.socketSvc.connect(userId);
    // this.socket.emit('register', userId, (res: any) => {
    //   console.log('Registration ack:', res);
    // });

    this.botService.llmModelStart().subscribe({
      next: (res: any) => {
        if (res?.session_id) {

          localStorage.setItem(
            'session_id',
            res.session_id
          );

          console.log(
            'Session created:',
            res.session_id
          );

        }
      },
      error: (err: any) => {
        console.error(
          'LLM session creation failed:',
          err
        );
      }
    });

    this.checkScreenSize();
  }

  private checkScreenSize(): void {

    const mobile = window.innerWidth < 992;

    this.isMobile = mobile;

    // Mobile drawer should always start closed
    if (mobile) {
      this.isMobileSidebarOpen = false;
    }

    // Desktop should not retain mobile drawer state
    if (!mobile) {
      this.isMobileSidebarOpen = false;
    }
  }


  // =========================================================
  // BROWSER RESIZE
  // =========================================================

  @HostListener('window:resize')
  onWindowResize(): void {

    const mobile = window.innerWidth < 992;

    // Only react when breakpoint actually changes
    if (mobile !== this.isMobile) {

      this.isMobile = mobile;

      // Close mobile drawer when switching modes
      this.isMobileSidebarOpen = false;
    }
  }


  // =========================================================
  // DESKTOP SIDEBAR COLLAPSE / EXPAND
  // =========================================================

  toggleSidebar(): void {

    // Do nothing on mobile
    if (this.isMobile) {
      return;
    }

    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }


  // =========================================================
  // MOBILE SIDEBAR OPEN / CLOSE
  // =========================================================

  toggleMobileSidebar(): void {

    // Do nothing on desktop
    if (!this.isMobile) {
      return;
    }

    this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
  }


  // =========================================================
  // CLOSE MOBILE SIDEBAR
  // =========================================================

  closeMobileSidebar(): void {
    this.isMobileSidebarOpen = false;
  }

  emitReadUpdate(response: any) {
    let updateDelivery = {};
    updateDelivery = _.pick(response, 'message_id', 'chat_type', 'from_user_id', 'to_user_id');
    // this.socketService.updateReadMessage(updateDelivery);
  }

  getUserStatusData() {
    this.headerService.getUserStatus().subscribe((res: any) => {
      this.userStatus = res;
    })
  }

  // observableRefresh() {

  //   try {

  //     if (window.localStorage.token) {
  //       if (this.subscribers.isSubscribed) {
  //         return;
  //       } else {
  //         this.subscribers.isSubscribed = true;
  //       }

  //       this.subscribers.userMessage = this.socketService.receiveNewUserMessage().subscribe((newMessage: any) => {
  //         const response = {
  //           message: newMessage,
  //           settings: this.userSetting
  //         };
  //         this.dataSharingService.emitNewUserMessage(response);
  //         if (this.activeUrl === 'chats' && this.actualUrl === 'singleuser') {
  //           const paramId = +this.router.url.split('/')[3];
  //           if ((newMessage && newMessage.from_user_id) === paramId && this.isWindowFocused) {
  //             this.emitReadUpdate(newMessage);
  //           } else {
  //             this.emitUpdateDelivery(newMessage);
  //             if (this.userSetting.enable_desktop_alert) {
  //               if (this.userSetting.user_msg_alert) {
  //                 this._notificationService.generateNotification(newMessage);
  //               }
  //             }
  //           }
  //         } else {
  //           this.emitUpdateDelivery(newMessage);
  //           if (this.userSetting.enable_desktop_alert) {
  //             if (this.userSetting.user_msg_alert) {
  //               this._notificationService.generateNotification(newMessage);
  //             }
  //           }
  //         }

  //         if (this.activeUrl !== 'chats') {
  //           this.dataSharingService.emitNotifyCount({ menu: 'chats', count: 0 });
  //         }

  //       });

  //       this.subscribers.groupMessage = this.socketService.receiveNewGroupMessage().subscribe((newMessage: any) => {
  //         const response = {
  //           message: newMessage,
  //           settings: this.userSetting
  //         };
  //         this.dataSharingService.emitNewGroupMessage(response);
  //         this.emitUpdateDelivery(newMessage);

  //         if (this.activeUrl === 'chats' && this.actualUrl === 'groupuser') {
  //           const paramId = +this.router.url.split('/')[3];
  //           if ((newMessage && newMessage.group_id) !== paramId) {
  //             if (this.userSetting.enable_desktop_alert) {
  //               if (this.userSetting.group_msg_alert) {
  //                 this._notificationService.generateNotification(newMessage);
  //               }
  //             }
  //           }
  //         }

  //         if (this.activeUrl !== 'chats') {
  //           // this.dataSharingService.emitNotifyCount('chats');
  //           this.dataSharingService.emitNotifyCount({ menu: 'chats', count: 0 });
  //           if (this.userSetting.enable_desktop_alert) {
  //             if (this.userSetting.group_msg_alert && newMessage.group_id) {
  //               this._notificationService.generateNotification(newMessage);
  //             }
  //           }
  //         }

  //       });

  //       this.subscribers.meetingSessions = this.socketService.meetingCallingSession().subscribe((session: any) => {
  //         if (session !== null && session !== undefined) {
  //           this.callingUserDetails = session
  //           this.callingUserDetails['type'] = true
  //         }
  //       })

  //       this.subscribers.callAccepted = this.socketService.callAccepted().subscribe((response: any) => {
  //         this.dataSharingService.emitCallAccepted(response)
  //       })
  //       // ice candidate
  //       this.subscribers.iceCandidate = this.socketService.icecandidate().subscribe((ice: any) => {
  //         this.dataSharingService.emitIceCandidate(ice)
  //       })

  //       this.subscribers.sdp = this.socketService.sdpSession().subscribe((sdp: any) => {
  //         this.dataSharingService.emitSdp(sdp)
  //       })


  //       this.subscribers.userStatusNotify = this.socketService.receiveUserStatus().subscribe((response: any) => {
  //         this.dataSharingService.emitUserStatusNotify(response);
  //       });


  //       this.subscribers.userTypingUpdate = this.socketService.receiveUserTypingStatus().subscribe((typingStatusData: any) => {
  //         this.dataSharingService.emitTypingStatusNotify(typingStatusData);
  //       });


  //       this.subscribers.initiateNewChat = this.socketService.receiveNewChat().subscribe((userChat: any) => {
  //         this.dataSharingService.emitNewChatsNotify(userChat);
  //       });


  //       this.subscribers.updateDelivery = this.socketService.updateDeliveredResponse().subscribe((deliveredMessage: any) => {
  //         this.dataSharingService.emitMessageUpdateNotify(deliveredMessage);
  //       });

  //       this.subscribers.readBulkMessage = this.socketService.readMessageOnTab().subscribe((readedMessage: any) => {
  //         this.dataSharingService.emitBulkReadMsgUpdateNotify(readedMessage);
  //       });


  //       this.subscribers.groupUpdate = this.socketService.receiveUpdateChatGroup().subscribe((updatedGroup: any) => {
  //         this.dataSharingService.emitGroupUpdateNotify(updatedGroup);
  //       });

  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // emitUpdateDelivery(response: any) {
  //   let updateDelivery = {};
  //   updateDelivery = _.pick(response, 'message_id', 'chat_type', 'from_user_id', 'to_user_id');
  //   this.socketService.updateDeliveredMessage(updateDelivery);
  // }

  getCurrentUserData(): void {
    this.headerService.getCurrentUserDetail().subscribe({
      next: (response: any) => {
        const {
          userDetail,
          settingsDetail,
          menuList
        } = response ?? {};

        // User details
        this.userDetail = userDetail ?? null;
        this.is_tour_completed = userDetail?.is_tour_completed ?? false;

        // Settings
        this.userSetting = settingsDetail ?? null;

        // Menu
        this.menuListItem = Array.isArray(menuList)
          ? menuList
          : [];

        // Store user profile globally
        if (userDetail) {
          this.coreService.setUserProfile(userDetail);
        }

        // Optional
        // this.socketService.initiateSocket();
        // this.observableRefresh();
      },

      error: (err: any) => {
        console.error('Get Current User Error:', err);

        if (err?.error?.logout) {
          this.handleLogout();
        }
      }
    });
  }

  private handleLogout(): void {
    localStorage.removeItem('llm_token');

    // Optional: clear other user/session data
    // localStorage.removeItem('user');
    // sessionStorage.clear();

    this.router.navigate(['/login']);
  }

  doBeforeUnload() {
    // Alert the user window is closing
    return false;
  }

  onFocus(event: FocusEvent): void {

    // Do something
    const payload = {
      user_id: this.userDetail.user_id,
      status_id: 0
    }

    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
    });

  }
  onBlur(event: FocusEvent): void {
    // Do something
    const payload = {
      user_id: this.userDetail.user_id,
      status_id: 0
    }

    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
    });

  }

  doUnload() {
    const payload = {
      user_id: this.userDetail.user_id,
      status_id: 0
    }

    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
    });
  }

  socketTyping(payLoad: any) {
    try {
      if (this.socketService) {
        this.socketService.emitUserTypingStatus(payLoad);
      }
    } catch (err) {
      console.log(err);
    }
  };

  updateUserOnboarding() {
    this.userService.updateUserOnboarding().subscribe((response: any) => {
      this.userDetail.is_tour_completed = true;
    }, error => {

    })
  };

  fileUploadWithProgess(formFields: any, filesList: any) {
    return new Promise((resolve, reject) => {
      const URL = `${BASE_URI.URL}/uploadFiles`;

      console.log(URL, 'url cotnent');


      if (filesList && filesList.length > 0) {
        const promise: any[] = [];
        filesList.map((el: any) => {
          promise.push(this.sendFileToServer(el, filesList, formFields).then(fileResp => {
            return fileResp;
          },
            error => {
              reject(error)
            }))
        });

        Promise.all(promise).then(allFileResponse => resolve(allFileResponse)).catch(err => reject(err));
      }
    })
  };


  sendFileToServer(file: any, filesList: any, formFields: any) {
    return new Promise((resolve, reject) => {
      const URL = `${BASE_URI.URL}/uploadFiles`;
      const formData: FormData = new FormData();
      formData.append(formFields.fieldName, file);
      formData.append('uniq', `${Date.now()}`);
      for (const key in formFields) {
        if (key) {
          formData.append(key, formFields[key]);
        }
      }

      const req = new HttpRequest('POST', URL, formData, { reportProgress: true });
      this.http.request(req).subscribe((event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          file.progressVal = Math.round(100 * event.loaded / event.total);
        }

        if (event.type === HttpEventType.Response) {
          const index = filesList.indexOf(file);
          filesList.splice(index, 1);
          resolve(event['body']);
        }
      },
        error => {
          reject(error);
        });
    });
  };

  //number validation
  commonValidateNumber(evt: any, labelName: any) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      this.alert.showAlertMessage({ message: 'Please enter number value only' })
      return false;
    }

    return true;
  }


  toggleSideMenu() {
    // let sidebar = this.document.querySelector('.sidebar');
    //    sidebar.classList.toggle('collapse-menu');
    this.userSetting.visible_sidebar = !this.userSetting.visible_sidebar;
  }

  ngAfterViewInit() {
    this.indexedDBService.initDB();
  }


  ngOnDestroy() {
    this.subscribers.isSubscribed = false;
    this.subscribers.userMessage.unsubscribe();
    this.subscribers.groupMessage.unsubscribe();
    this.subscribers.userStatusNotify.unsubscribe();
    this.subscribers.userTypingUpdate.unsubscribe();
    this.subscribers.initiateNewChat.unsubscribe();
    this.subscribers.updateDelivery.unsubscribe();
    this.subscribers.readBulkMessage.unsubscribe();
    this.subscribers.groupUpdate.unsubscribe();

    window.removeEventListener('dragover', this.dragOverHandler, false);
    window.removeEventListener('drop', this.dropHandler, false);
    window.removeEventListener('focus', this.focusHandler, false);
    window.removeEventListener('blur', this.focusBlurHandler, false);
  };
}
